'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var toastStyles = {"toast__container":"toast-module_toast__container__CUJtw","toast__message":"toast-module_toast__message__5xULk","success":"toast-module_success__vuSq4","error":"toast-module_error__8fKb-","warning":"toast-module_warning__T5FRL","btn-ghost":"toast-module_btn-ghost__hPzuD","toast__dismisser":"toast-module_toast__dismisser__iTSFX","toast__message-container":"toast-module_toast__message-container__b2CWE","fadein-only":"toast-module_fadein-only__6xLWs","fadein":"toast-module_fadein__0qQCr","fadein-fadeout":"toast-module_fadein-fadeout__h-BB0","fadeout":"toast-module_fadeout__IqLBk"};

exports.default = toastStyles;
//# sourceMappingURL=toast.module.scss.js.map
